/**
 * Carrito: selector de talla.
 *
 * El <select class="lov-cart-size"> lo dibuja snippets/quantity-selector.liquid en
 * cada línea del carrito (drawer y página). Aquí se maneja el cambio de talla:
 *
 *  1. Se agrega al carrito la nueva variante con la misma cantidad
 *     (/cart/add.js). Si falla (por ejemplo, sin stock), no se toca la línea
 *     original: el selector vuelve a la talla anterior y se muestra el error.
 *  2. Se quita la línea anterior por su "key" (/cart/change) pidiendo también el
 *     HTML actualizado de las secciones del carrito.
 *  3. Se avisa al tema igual que lo hace él al cambiar una cantidad (evento
 *     CartUpdateEvent + morphSection), para que se actualicen la línea, el total,
 *     la barra de envío gratis y el contador del ícono de la bolsa.
 *
 * Los módulos del tema (@theme/...) se cargan con import() la primera vez que se
 * usan, así este archivo no depende del orden del importmap en el <head>.
 */
(function () {
  'use strict';

  var modulesPromise = null;

  function loadThemeModules() {
    if (!modulesPromise) {
      modulesPromise = Promise.all([
        import('@theme/section-renderer'),
        import('@theme/events'),
        import('@theme/utilities'),
      ]);
    }
    return modulesPromise;
  }

  function showError(row, message) {
    var container = row.querySelector('.cart-items__error');
    var text = row.querySelector('.cart-item__error-text');
    if (!container || !text) return;
    text.textContent = message;
    container.classList.remove('hidden');
  }

  async function changeSize(select) {
    var component = select.closest('cart-items-component');
    var row = select.closest('.cart-items__table-row');
    if (!component || !row) return;

    var previousId = select.dataset.currentVariant;
    var newId = select.value;
    if (!newId || newId === previousId) return;

    var lineKey = row.dataset.key;
    var sectionId = component.dataset.sectionId;
    if (!lineKey || !sectionId) {
      select.value = previousId;
      return;
    }

    var quantityInput = row.querySelector('cart-quantity-selector-component input');
    var quantity = Math.max(parseInt(quantityInput && quantityInput.value, 10) || 1, 1);

    // Igual que el tema: se actualizan las secciones de todos los carritos de la página
    var sectionIds = new Set([sectionId]);
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });

    component.classList.add('cart-items-disabled');
    select.disabled = true;

    var added = false;

    try {
      var mods = await loadThemeModules();
      var morphSection = mods[0].morphSection;
      var CartUpdateEvent = mods[1].CartUpdateEvent;
      var fetchConfig = mods[2].fetchConfig;

      function post(url, body) {
        return fetch(url, fetchConfig('json', { body: JSON.stringify(body) })).then(function (response) {
          return response.json();
        });
      }

      // 1) Agregar la nueva talla
      var addResult = await post(Theme.routes.cart_add_url, {
        items: [{ id: Number(newId), quantity: quantity }],
      });

      if (addResult.status || addResult.errors) {
        throw new Error(addResult.description || addResult.message || 'No se pudo cambiar la talla.');
      }
      added = true;

      // 2) Quitar la línea anterior y traer el HTML actualizado del carrito
      var cart = await post(Theme.routes.cart_change_url, {
        id: lineKey,
        quantity: 0,
        sections: Array.from(sectionIds).join(','),
        sections_url: window.location.pathname,
      });

      if (cart.errors || !cart.sections || !cart.sections[sectionId]) {
        throw new Error(cart.errors || 'No se pudo actualizar el carrito.');
      }

      // 3) Avisar al tema y actualizar la vista, como lo hace al cambiar una cantidad
      var newHtml = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
      var countElement = newHtml.querySelector('[ref="cartItemCount"]');
      var itemCount = countElement ? parseInt(countElement.textContent, 10) : 0;

      component.dispatchEvent(
        new CartUpdateEvent(cart, sectionId, {
          itemCount: itemCount,
          source: 'cart-items-component',
          sections: cart.sections,
        })
      );

      morphSection(sectionId, cart.sections[sectionId], {
        mode: component.dataset.drawer !== undefined ? 'hydration' : 'full',
      });
    } catch (error) {
      select.value = previousId;
      showError(row, error && error.message ? error.message : String(error));

      // Si la nueva talla ya se había agregado pero no se pudo quitar la anterior,
      // se vuelve a pintar el carrito para mostrar lo que realmente contiene.
      if (added) {
        try {
          var renderer = (await loadThemeModules())[0].sectionRenderer;
          renderer.renderSection(sectionId, { cache: false });
        } catch (renderError) {}
      }
    } finally {
      component.classList.remove('cart-items-disabled');
      select.disabled = false;
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.classList.contains('lov-cart-size')) return;
    changeSize(select);
  });
})();
